/**
 * Machine-readable codes carried in the body of a failed account action.
 *
 * The storefront needs to tell "this password is wrong" apart from "this account exists but was
 * never verified", because only the second one has a fix the shopper can perform. Two things rule
 * out the obvious ways of doing that:
 *
 * - The SDK's fetcher returns `{ frontasticRequestId, error, isError }` and drops `response.status`
 *   entirely, so the HTTP status never reaches the caller.
 * - Matching on the human-readable `message` would make a copy edit a functional change.
 *
 * So the code travels in the body, and it lives in the shared types package so that the producer
 * (`AccountController`) and the consumer (`login-form`) cannot drift apart silently.
 */
export const ACCOUNT_NOT_CONFIRMED_ERROR_CODE = 'account_not_confirmed';
